/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to rematch rooms for a specific level pair
 * @export
 * @interface RematchRoomsRequest
 */
export interface RematchRoomsRequest {
    /**
     * Level ID from estimate A (UUID string)
     * @type {string}
     * @memberof RematchRoomsRequest
     */
    levelIdA: string;
    /**
     * Level ID from estimate B (UUID string)
     * @type {string}
     * @memberof RematchRoomsRequest
     */
    levelIdB: string;
}

/**
 * Check if a given object implements the RematchRoomsRequest interface.
 */
export function instanceOfRematchRoomsRequest(value: object): value is RematchRoomsRequest {
    if (!('levelIdA' in value) || value['levelIdA'] === undefined) return false;
    if (!('levelIdB' in value) || value['levelIdB'] === undefined) return false;
    return true;
}

export function RematchRoomsRequestFromJSON(json: any): RematchRoomsRequest {
    return RematchRoomsRequestFromJSONTyped(json, false);
}

export function RematchRoomsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RematchRoomsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'levelIdA': json['levelIdA'],
        'levelIdB': json['levelIdB'],
    };
}

export function RematchRoomsRequestToJSON(json: any): RematchRoomsRequest {
    return RematchRoomsRequestToJSONTyped(json, false);
}

export function RematchRoomsRequestToJSONTyped(value?: RematchRoomsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'levelIdA': value['levelIdA'],
        'levelIdB': value['levelIdB'],
    };
}

